import Report from '@xpeng/report-js'
import jsbridge from '@xpeng/js-bridge'
import jsCookie from 'js-cookie'
import { getClientEnv, isMock, isXpAPP } from './common'

const CAR_OWNER_FLAG = {
  '0': '未知',
  '1': '车主',
  '2': '潜客',
  '3': '租客',
  '4': '授权使用人',
}

const MATCHED_CAR_OWNER_FLAG = [1, 3]
const REMATCH_CAR_OWNER_FLAG = [0, 2, 4]


/**
 * 获取用于上报的用户信息
 * 规则:
 * 1. carownerflag 为[1, 3, 4] 即匹配车主、租客时直接返回该角色
 * 2. 当 carownerflag 为[0, 2] 即匹配未知、游客、授权使用人时，继续判断 orderType 字段，为 1 时返回 预定车主 角色，否则返回 潜客
 */
export async function getUserInfoForReport() {
  const userInfoFromCookie = jsCookie.get('__ds_report_user_info__')

  if(userInfoFromCookie) {
    return JSON.parse(userInfoFromCookie)
  }

  let storeData = {
    uid: -1,
    ut: '潜客',
  }

  // 非 APP 环境下通过 SSO 接口获取用户信息
  if (!isXpAPP() && !isMock()) {
    try {
      const res = await fetch(`/webAuthSdk/checkLoginStatus?frontRedirect=${encodeURIComponent(window.location.href)}`, {
        method: 'GET',
        credentials: 'include',
      }).then((r) => r.json())
      if (res.code === 200 && res.data?.uid) {
        storeData.uid = res.data.uid
        jsCookie.set('__ds_report_user_info__', JSON.stringify(storeData))
      }
    } catch {}
    return storeData
  }

  const res = await jsbridge.callHandler('getLoginState')

  const uid = res?.data?.uid
  const carOwnerFlag = res?.data?.carownerflag
  const orderType = res?.data?.orderType

  if (MATCHED_CAR_OWNER_FLAG.includes(carOwnerFlag)) {
    storeData.ut = CAR_OWNER_FLAG[`${carOwnerFlag}`]
  } else if (REMATCH_CAR_OWNER_FLAG.includes(carOwnerFlag)) {
    storeData.ut = orderType === 1 ? '预定车主' : '潜客'
  }

  if (uid && uid > 0) {
    storeData.uid = uid
    jsCookie.set('__ds_report_user_info__', JSON.stringify(storeData))
  }

  return storeData
}

/**
 * 埋点上报
 * @param appid 业务id
 * @param so 打点业务方
 * @param ch 渠道来源，多级渠道来源用"_"分隔
 * @param mcode 日志类型代码
 * @param pa 业务自定义参数
 * @param ut 用户类型： 1-潜客， 2-预定车主， 3-车主
 * @param type 类型： 页面曝光-page， 页面元素曝光-element， 事件-event
 */
export async function reportUserBehavior(
  { appid = 'J001', so, mcode, pa='' ,ch = '' },
  type = 'event'
) {

  const useInfoForReport = await getUserInfoForReport()
  let padData = {}

  if(useInfoForReport?.uid > 0) {
    padData = {...useInfoForReport}
  }

  const env = getClientEnv();
  const report = new Report(
    {
      appid,
      so,
      mcode,
      pa,
      ch,
      ...padData
    },
    { env: env === 'dev' ? 'test' : env }
  )

  report.send({ type })
}
